import moment from 'moment';

export const isObligationDocument = (document) =>
  document?.documentType === 'OBLIGATION';

/** Solo obligaciones tipo invoice pueden copiarse desde el panel de conciliación. */
export const canCopyObligationDocument = (document) =>
  isObligationDocument(document) && document?.meta?.type === 'invoice';

/**
 * Datos iniciales para CreateObligationModal en modo copia (nueva obligación, sin conciliar origen).
 */
export const buildObligationCopyInitialData = (document) => {
  if (!document || !canCopyObligationDocument(document)) return null;

  const meta = document.meta || {};
  const exchange = meta.exchange || {};
  const currency =
    exchange.originalCurrency || meta.currency || document.currencyType || 'CLP';
  const originalAmount =
    exchange.originalAmount ??
    meta.originalAmount ??
    document.amount ??
    meta.amount ??
    0;
  const exchangeRate = exchange.exchangeRate ?? meta.rate ?? '';
  const fecha = document.documentDate
    ? moment(document.documentDate).format('YYYY-MM-DD')
    : moment().format('YYYY-MM-DD');

  const agendaIdRaw = document.agendaId ?? meta.counterpartId;
  const agendaId = Array.isArray(agendaIdRaw) ? agendaIdRaw[0] : agendaIdRaw;

  return {
    documentType: 'OBLIGATION',
    isObligationCopy: true,
    meta: { ...meta },
    currency,
    currencyType: document.currencyType || currency,
    amount: originalAmount,
    documentDate: document.documentDate,
    originalDueDate: document.originalDueDate,
    cashflowAreaId: document.cashflowAreaId || '',
    fieldKey: document.fieldKey || '',
    agendaId: agendaId || undefined,
    issuer: document.issuer,
    receiver: document.receiver,
    issuerName: document.issuerName,
    receiverName: document.receiverName,
    copyPrefill: {
      obligationType: meta.type || 'invoice',
      amount: String(originalAmount),
      fecha,
      description: meta.description || '',
      documentId: meta.documentId != null ? String(meta.documentId) : '',
      referenceNumber: meta.referenceNumber || '',
      invoiceCurrency: currency !== 'CLP' ? currency : '',
      invoiceExchangeRate:
        currency !== 'CLP' && exchangeRate != null && exchangeRate !== ''
          ? String(exchangeRate)
          : '',
      initialIsReceived: meta.isReceived !== undefined ? meta.isReceived : true,
    },
  };
};
